<template>
		<v-row justify="center">
			<v-dialog 
				v-model="businessDialog" 
				persistent 
				max-width="600"
				:retain-focus="false"
			>
				<!-- Boton de activacion Modal -->
				<template v-slot:activator="{ on }">
					<v-col align="right" justify="center" class="my-3">
						<v-btn class="mt-2" fab dark color="secondary" v-on="on">
							<v-icon dark>mdi-plus</v-icon>
						</v-btn>
					</v-col>
				</template>
				<v-card>
					<v-card-title class="headline">{{ businessDialogEditMode ? 'EDITAR' : 'CREAR'}} NEGOCIO</v-card-title>
						<v-card-text>
								<v-form v-model="formValidity">
									<v-row>
										<v-col cols="12" md="6">
											<v-text-field
												color="admin_accent"
												v-model="businessForEdit.name"
												label="Nombre"
												prepend-inner-icon="mdi-account-circle"
												:rules="textRules"
												dense
												filled />
											<v-text-field
												color="admin_accent"
												v-model="businessForEdit.subtitle"
												label="Subtítulo"
												prepend-inner-icon="mdi-account-circle"
												:rules="textRules"
												dense
												filled />
											<v-text-field
												color="admin_accent"
												v-model="businessForEdit.phone"
												label="Teléfono"
												prepend-inner-icon="mdi-cellphone-basic"
												:rules="textRules"
												dense
												filled /> 
											<v-textarea
													color="admin_accent"
													filled
													v-model="businessForEdit.address"
													prepend-inner-icon="mdi-message-reply-text"
													label="Dirección"
													:value="businessForEdit.address"
													rows="2"
											></v-textarea>
											<v-text-field
												color="admin_accent"
												v-model="businessForEdit.facebook"
												prepend-inner-icon="mdi-facebook"
												label="Facebook"
												dense
												filled />
											<v-text-field
												color="admin_accent"
												v-model="businessForEdit.instagram"
												prepend-inner-icon="mdi-instagram"
												label="Instagram"
												dense
												filled />
											<v-text-field
												color="admin_accent"
												v-model="businessForEdit.twitter"
												prepend-inner-icon="mdi-twitter"
												label="Twitter"
												dense
												filled />
											<v-text-field
												color="#212121"
												:background-color="businessForEdit.color_primary"
												v-model="businessForEdit.color_primary"
												label="Color Primary"
												filled
												dense
												 />
											<v-text-field
												color="#212121"
												:background-color="businessForEdit.color_secondary"
												v-model="businessForEdit.color_secondary"
												label="Color Secondary"
												filled
												dense
												 />
											<v-text-field
												color="#212121"
												:background-color="businessForEdit.color_accent"
												v-model="businessForEdit.color_accent"
												label="Color Accent"
												filled
												dense
												 />


										</v-col>
										<v-col cols="12" md="6">

										<v-menu
											ref="menuExpiration"
											v-model="menuExpiration"
											:close-on-content-click="false"
											transition="scale-transition"
											offset-y
											min-width="290px"

										>
											<template v-slot:activator="{ on }">
												<v-text-field
													v-model="expirationFormatted"
													label="Fecha Vencimiento"
													readonly v-on="on"
												></v-text-field>
											</template>
											<v-date-picker
												v-model="expirationDate"
												no-title scrollable
												:min="minDate"
												locale="es-es"
												@input="menuExpiration = false"
											>
												<v-spacer></v-spacer>
											</v-date-picker>
										</v-menu>





											
											<v-switch
													inset class="ma-2"
													color="success"
													v-model="businessForEdit.template"
													:label="`Template: ${businessForEdit.template ? 'completo' : 'simple'}`"
											></v-switch>
											<v-switch
													inset class="ma-2"
													color="success"
													v-model="businessForEdit.footer"
													:label="`Footer: ${businessForEdit.footer ? 'mostrar' : 'sin'}`"
											></v-switch>
										


											<v-switch
													inset class="ma-2"
													color="success"
													v-model="businessForEdit.active"
													:label="`Estado: ${businessForEdit.active ? 'Activo' : 'Inactivo'}`"
											></v-switch>

											<v-select
												v-model="customer"
												:items="customers"
												item-text="name"
												item-value="id"
												label="Seleccione Cliente"
												persistent-hint
												return-object
												single-line
											></v-select>
							
											<v-card>
												<image-uploader
													ref="imager"
													:maxWidth="600"
													:quality="0.7"
													:preview="true"
													:className="['fileinput', { 'fileinput--loaded': hasImage }]"
													:capture="false"
													:debug="1"
													doNotResize="gif"
													:autoRotate="true"
													outputFormat="verbose"
													@input="setImage"
												>
													<label for="fileInput" slot="upload-label">
														<v-img 
															v-if="showImage"
															:src="(photoExist) ? businessForEdit.photo_url : noImage"
															aspect-ratio="1.778"
														/>
														<figure>
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="32"
																height="32"
																viewBox="0 0 32 32"
															>
																<path
																	class="path1"
																	d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
																></path>
															</svg>
														</figure>
														<span class="upload-caption">{{
															hasImage ? "Click Reemplazar" : "Click para subir"
														}}</span>
													</label>
												</image-uploader>
											</v-card>																			
											<v-switch
													inset class="ma-2"
													color="success"
													v-model="businessForEdit.homeimageheader"
													:label="`Imagen en Home: ${businessForEdit.homeimageheader ? 'Si' : 'No'}`"
											></v-switch>
										</v-col>
									</v-row>
								</v-form>
						</v-card-text>
						<v-card-actions>
						<v-spacer></v-spacer>
							<v-btn :loading="loading" class="white--text" color="admin_accent" @click="update" v-if="businessDialogEditMode">ACTUALIZAR NEGOCIO</v-btn>
							<v-btn :loading="loading" class="white--text" color="admin_accent" @click="add" v-else>CREAR NEGOCIO</v-btn>
							<v-btn outlined color="secondary" @click="close">CANCELAR</v-btn>
						</v-card-actions>
				</v-card>

			</v-dialog>
		</v-row>
</template>
<script>
	import moment from 'moment';
	import { mapState, mapActions, mapGetters} from 'vuex';
	import { db, storage } from '@/main';
	export default {
		created(){
			this.getCustomers()
		},
		mounted(){

							//console.log(this.$refs.imager)

			
		},
		data: () => ({
			menuExpiration: false,
			minDate: new Date().toISOString().substr(0, 10),
			loading: false,
			hasImage: false,
			noImage: '/static/images/not-logo.jpg',
			photo: {
				dataUrl: '/static/images/not-logo.jpg'
			},
			uploaded: false,
			formValidity: false,
			textRules: [v => !!v || "Este dato es requerido"],
			emailRules: [
				value => !!value || 'Email is required.',
				value => value.indexOf('@') !== 0 || 'Email shoud have a username',
				value => value.includes('@') || 'Email should include an @ symbol',
				value => value.indexOf('.') - value.indexOf('@') > 1 || 'Email should contain a valid domain.',
				value => value.indexOf('.') <= value.length - 3 || 'Email should contain a valid domain extension'
			],
			select: { id: '', name: '' },
		}),
		methods:{
			...mapActions('customerModule', ['getCustomers']),
			setImage: function(output) {
				this.hasImage = true;
				this.photo = output;
				this.uploaded = true;
				this.businessForEdit.photo_url = null
			},
			 async add(){
				 this.loading = true;
				this.businessForEdit.id = Math.floor(Date.now() / 1000).toString();
				//this.businessForEdit.registration_date = 	Math.floor(Date.now() / 1000).toString();

				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`business/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.businessForEdit.photo_url = await refPhoto.getDownloadURL()
					this.businessForEdit.photo_name = fileNamePhoto
					this.hasImage = false;
					this.photo = null;
					this.uploaded = false;
				}

				db.collection('bussiness').doc(this.businessForEdit.id)
					.set( this.businessForEdit )
					.then( docRef => {
						this.close();
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,
							color: 'success',
							message: 'Negocio creado satisfactoriamente',
							timeout: 2000
						});	
						this.loading = false;
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
						this.loading = false;
					})
			},
			async update(){
				this.loading = true;
				if (this.uploaded) {
					var fileNamePhoto = Math.floor(Date.now() / 1000)
					const refPhoto =  storage.ref(`business/${fileNamePhoto}`)
					const res = await refPhoto.putString(this.photo.dataUrl, 'data_url')
					this.businessForEdit.photo_url = await refPhoto.getDownloadURL()
					this.businessForEdit.photo_name = fileNamePhoto
					this.hasImage = false;
					this.photo = null;
					this.uploaded = false;
				}

				db.collection('bussiness').doc(this.businessForEdit.id)
					.update( this.businessForEdit )
					.then( docRef => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true,color: 'success',timeout: 2000,
							message: 'Negocio actualizado satisfactoriamente',
						});	
						this.close();
						this.loading = false;
					})
					.catch( e => {
						this.$store.commit('SET_ALERT_MESSAGE', {
							show: true, color: 'error',timeout: 3000,	message: e.message,			
						});	
						this.loading = false;
					})
			},
			close(){
				this.$store.dispatch('businessModule/toggleBusinessDialog', {
					editMode: false,
					business: {
						id: null,
						active: true,
						homeimageheader: true,
						footer: true,
						template: true,					
						address: '',
						customer_id: '',
						customer_name: '',
						facebook: '',
						instagram: '',
						name: '',
						subtitle:'',
						phone: '',
						photo_name: '',
						photo_url: '',
						twitter: '',
						expiration_date: null,
						registration_date: null,
						color_primary: '#fff',
						color_secondary: '#C1272D',
						color_accent: '#636363',
					}
				});
				this.hasImage = false;
				this.photo = null;
				this.uploaded = false;
				this.$refs.imager['imagePreview'] = null;
				this.businessForEdit.photo_url = null

			},
			convertDateToTimeStamp(date, time){
				if (!date) return null
				const [year, month, day] = date.split('-')
				const [hour, min] = time.split(':')
				return moment(`${year}-${month}-${day} ${hour}:${min}:00`).format("X")
			},
		
		}, // .methods
		computed: {
			...mapState('customerModule',['customers']),
			...mapState('businessModule',['business','dialog',]),
			...mapGetters('businessModule',['businessForEdit', 'businessDialogEditMode','businessesDialog','customerForEdit']),
			photoExist(){
				return (this.businessForEdit.photo_url != '' && this.businessForEdit.photo_url !== null )
			},
			showImage(){
				return !this.hasImage && (this.businessForEdit.photo_url != '')
			},
			businessDialog: {
				get(){
					return this.businessesDialog;
				},
				set(){
					this.close()
				}
			},
			customer: {
				get(){
					return this.customerForEdit;
				},
				set(value){
					this.businessForEdit.customer_id = value.id
					this.businessForEdit.customer_name = value.name
				}
			},
			expirationFormatted () {
				return moment.unix(this.businessForEdit.expiration_date).format('DD-MM-YYYY');

				// const [year, month, day] = this.businessForEdit.expiration_date.split('-')
        // return `${day}-${month}-${year}`
			},
			expirationDate: {
				get(){
					if (this.businessForEdit.expiration_date == null || 
							this.businessForEdit.expiration_date == '') {
						this.businessForEdit.expiration_date = moment(Date.now()).add(1, 'year').unix();
					} 
					return moment.unix(this.businessForEdit.expiration_date).format('YYYY-MM-DD');
				},
				set(value){
					this.businessForEdit.expiration_date = moment(value).unix();
				}
			}


		} // .computed

	}
</script>

<style>
#fileInput {
	display: none;
}

#app > div.v-dialog__content.v-dialog__content--active > div > div > div.v-card__text > form > div > div:nth-child(2) > div > div > img {
	width: 100% !important;
}
</style>